import { CustomField, CustomFieldSelections } from '../types/custom-field'
import { http } from '../services/http'

export const fetchCustomFields = async (): Promise<Array<CustomField>> => {
  const response = await http.get<Array<CustomField>>('/v2/custom-fields')
  return initializeFilterVariables(response.data)
}

const initializeFilterVariables = (customFields: Array<CustomField>): Array<CustomField> => {
  customFields.forEach(field => {
    const initialSelections = {
      selected_options: []
    } as CustomFieldSelections
    field.selections = initialSelections
  })

  return customFields
}
